// main.js
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import axios from '@/plugins/axios'

// 1. 引入 Element Plus
import ElementPlus from 'element-plus'
// 2. 引入 Element Plus 样式
import 'element-plus/dist/index.css'

const app = createApp(App)

// 全局配置 axios
app.config.globalProperties.$axios = axios
app.provide('axios', axios)

// 3. 使用 Element Plus
app.use(ElementPlus)
app.use(router)

app.mount('#app')